export enum EmployerStatusTypeEnum {
  Inactive = 0,
  Active = 1
}
